import { isValid } from 'date-fns';
import { START_OF_DAY_TIME_VALUES } from '../../../../../../constants';

type NormalizedDateTimeRange = {
  normalizedFromDateTime: Date;
  normalizedToDateTime: Date;
  showTime: boolean;
  shouldResetAllowTime: boolean;
};

export const normalizeDateTimeRange = (
  fromDateTime: Date,
  toDateTime: Date,
  hasCorrectValue: boolean,
  hasTime: boolean,
  forceAllowTime: boolean,
  minValue: Date | null,
  maxValue: Date | null
): NormalizedDateTimeRange => {
  const showTime = hasTime || forceAllowTime;
  let normalizedFromDateTime = fromDateTime;
  let normalizedToDateTime = toDateTime;
  if (!hasCorrectValue) {
    if (minValue) {
      if (normalizedFromDateTime < minValue) {
        normalizedFromDateTime = new Date(minValue.getTime());
      }
      if (normalizedToDateTime < minValue) {
        normalizedToDateTime = new Date(minValue.getTime());
      }
    }
    if (maxValue) {
      if (normalizedFromDateTime > maxValue) {
        normalizedFromDateTime = new Date(maxValue.getTime());
      }
      if (normalizedToDateTime > maxValue) {
        normalizedToDateTime = new Date(maxValue.getTime());
      }
    }
  }
  // Never let an unparseable value reach format() below — it throws on Invalid Date.
  if (!isValid(normalizedFromDateTime)) {
    normalizedFromDateTime = new Date();
  }
  if (!isValid(normalizedToDateTime)) {
    normalizedToDateTime = new Date();
  }
  const shouldResetAllowTime = !hasTime;
  if (shouldResetAllowTime) {
    normalizedFromDateTime.setHours(...START_OF_DAY_TIME_VALUES);
    normalizedToDateTime.setHours(...START_OF_DAY_TIME_VALUES);
  }
  return {
    normalizedFromDateTime,
    normalizedToDateTime,
    showTime,
    shouldResetAllowTime,
  };
};
